import clsx from 'clsx';

import { Box } from '@highlight-cp/core-ui';

import type { Role } from '../ai-chat-types';
import { MarkdownProse } from '../markdown-prose';
import classes from './ai-chat-window-message.module.css';

interface AiChatWindowMessageStringProps {
  content: string;
  role: Role;
  index: number;
}

/**
 * ### AIChatWindowMessage
 *
 * @description
 * Renders a chat message with markdown formatting support.
 * Supports lists, headings, bold text, code blocks, and more.
 *
 * @param props - Component props
 * @returns React component
 */
const AIChatWindowMessage = ({ content, role }: AiChatWindowMessageStringProps) => {
  return (
    <Box className={clsx(classes.message, classes[role])}>
      <MarkdownProse>{content}</MarkdownProse>
    </Box>
  );
};

export default AIChatWindowMessage;
